module.exports = __webpack_public_path__ + "img/galeria_09.9dc28b0d.jpg";